module.exports = __webpack_public_path__ + "static/Rachel Cheng.5a2d6f3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Rachel Cheng.jpg
// module id = 1230
// module chunks = 6166952557895